import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import submit from "submit-form";

const INITIAL_STATE = {
  name: "",
  url: "",
  product: "",
  category: "",
  description: "",
};

const AddTutorialModal = ({
  tutorialCategories = [],
  selectedTutorial = null,
  product,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [form, setForm] = useState(
    Object.assign({}, INITIAL_STATE, { product })
  );

  const handleForm = (field, value) => {
    setForm(Object.assign({}, form, { [field]: value }));
  };

  useEffect(() => {
    if (!selectedTutorial) return;
    const { _id, name, product, url, category, description } = selectedTutorial;
    setForm(
      Object.assign({}, form, {
        _id,
        name,
        product,
        url,
        category,
        description,
      })
    );
    return () => {
      setForm(Object.assign({}, INITIAL_STATE, { product }));
    };
  }, [selectedTutorial]);

  return (
    <div>
      <form
        action={`/actions/admin-panel/manage-category/video${
          selectedTutorial ? "/update" : ""
        }`}
        method="POST"
        id="add-tutorial"
      >
        <input
          type="hidden"
          name="video"
          value={selectedTutorial ? selectedTutorial._id : null}
        />
        <Modal
          className="add-tutorial-modal"
          width="1100px"
          onClose={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                selectedTutorial: "",
                "modal[type]": "",
              },
            });
          }}
          title={t("addTutorialModal.title")}
        >
          <div className="body">
            <div className="right-panel">
              <div className="input-section">
                <label>{t("addTutorialModal.titleLabel")}</label>
                <input
                  name="name"
                  className="text-input"
                  placeholder={t("addTutorialModal.titlePlaceholder")}
                  value={form.name}
                  onChange={({ target: { value } }) =>
                    handleForm("name", value)
                  }
                />
              </div>
              <div className="input-section">
                <label>{t("addTutorialModal.linkVideo")}</label>
                <input
                  name="url"
                  className="text-input"
                  placeholder={t("addTutorialModal.linkVideoPlaceholder")}
                  value={form.url}
                  onChange={({ target: { value } }) => handleForm("url", value)}
                />
              </div>
              <input type="hidden" name="product" value={form.product} />

              <div className="input-section">
                <label>{t("addTutorialModal.category")}</label>
                <div
                  style={{
                    marginBottom: 16,
                  }}
                >
                  <select
                    name="category"
                    className="select-input rounded-select"
                    placeholder={t("addTutorialModal.categoryPlaceholder")}
                    value={form.category}
                    onChange={({ target: { value } }) =>
                      handleForm("category", value)
                    }
                  >
                    {selectedTutorial ? (
                      <option value="null">
                        {t("addTutorialModal.uncategorized")}
                      </option>
                    ) : null}
                    {(tutorialCategories || []).map((item, idx) => {
                      return (
                        <option key={idx} value={item.name}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="left-panel">
              <div
                className="input-section"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>{t("addTutorialModal.description")}</label>
                <textarea
                  name="description"
                  className="textarea-input"
                  placeholder={t("addTutorialModal.descriptionPlaceholder")}
                  style={{
                    height: "100%",
                  }}
                  value={form.description}
                  onChange={({ target: { value } }) =>
                    handleForm("description", value)
                  }
                />
              </div>
            </div>
          </div>
          <footer>
            <button data-button-type="primary" type="submit">
              {selectedTutorial
                ? t("addTutorialModal.update")
                : t("addTutorialModal.create")}
            </button>
          </footer>
        </Modal>
      </form>
    </div>
  );
};

export default AddTutorialModal;
